import { Tokens } from 'modules/oauth/types/Tokens';
export const isWithinAnotherApp = (): boolean => (window.tiw ? true : false);

export const desktopLogout = (reason?: string): void => {
  if (isWithinAnotherApp()) {
    window.tiw.send('logout', reason);
  }
};

export const updateToken = (newToken: Tokens): void => {
  if (isWithinAnotherApp()) {
    window.tiw.send('update-token', newToken);
  }
};

export const goToTimesheet = (wtsUiEndpoint: string | undefined): void => {
  if (isWithinAnotherApp()) {
    window.tiw.send('go-to-timesheet', wtsUiEndpoint);
  }
};

export const collectorInstall = (installURL: string): void => {
  window.tiw.send('collector-install', installURL);
};

export const collectorUninstall = (uninstallURL: string): void => {
  window.tiw.send('collector-uninstall', uninstallURL);
};

export const getDesktopVersion = (): string => {
  return window.localStorage.desktopVersion;
};
